import { Fragment } from 'react';
import { useSelector } from 'react-redux';
import { FilteringForm, initialFilteringValues, filteringValidationSchema } from './FilteringForm';
import { PageHeader } from '../../../components/PageHeader';
import { Formik } from "formik";
import OpenInBrowserOutlinedIcon from '@material-ui/icons/OpenInBrowserOutlined';
import Button from '@material-ui/core/Button';


export const ListingPageHeader = (props) => {

    const {
        setCreating,
        handleFilterChange,
        onExport
    } = props;

    return (
        <PageHeader title="院友總覽">
            <Formik
                initialValues={initialFilteringValues}
                validationSchema={filteringValidationSchema}
            >
                {() => (
                    <Fragment>
                        <FilteringForm
                            handleFilterChange={handleFilterChange}
                        />
                        <Button
                            variant="contained"
                            color="primary"
                            startIcon={<OpenInBrowserOutlinedIcon />}
                            onClick={onExport}
                        >
                            匯出
                        </Button>
                    </Fragment>
                )}
            </Formik>
        </PageHeader >
    );
}
